module.exports = __webpack_public_path__ + "img/autosense-amag-flow.67af7dde.png";